import { trackAnalytics } from '@client/intercom';
import { firebaseRequest, handleRequest } from '@client/listeners/lib/requests';
import { startAddBeaconImpression } from '@client/slices/entities/beacons.reducer';
import { ProfileTypes } from '@sda/enums';
import { apiUrl } from '@sda/utils/url';
import { getUserId } from '@client/selectors/helpers/login';
import type { AddListener } from '@client/listeners/lib';

export const connectDetailsListeners = (addListener: AddListener) => [
  addListener({
    actionCreator: startAddBeaconImpression,
    effect: async (action, listenerApi) => {
      const beaconId = action.payload;
      const state = listenerApi.getState();

      const userId = getUserId(state);

      try {
        const request = await firebaseRequest({
          url: apiUrl(`beacon/${beaconId}/impression`),
          method: 'PUT',
        });

        listenerApi.fork(async () => {
          try {
            await handleRequest(request);
          } catch (e) {
            console.log(e);
          }
        });

        const firebase = window.Firebase;
        const beacon = await firebase.SDK.Beacons.get(beaconId);

        trackAnalytics(startAddBeaconImpression, {
          beaconId,
          isSignedIn: !!userId,
          isArtistBeacon: beacon.profileType === ProfileTypes.ACT,
        });
      } catch (e) {
        console.log(e);
      }
    },
  }),
];
